var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwipe = function SvgSwipe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.45 11.875-3.235-1.613a1.56 1.56 0 0 0-.704-.167h-.72V5.35c0-.656-.53-1.186-1.186-1.186-.657 0-1.187.53-1.187 1.186v8.494l-2.57-.585a.783.783 0 0 0-.728.222l-.656.664 3.59 3.788c.3.3.902.467 1.321.467h4.872c.791 0 1.456-.577 1.566-1.36l.498-3.528a1.589 1.589 0 0 0-.862-1.637Z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.43 3.27C15.291 1.925 12.847 1 10 1c-2.847 0-5.291.925-6.43 2.27L2.09 1.79v3.955h3.955L4.408 4.108C5.2 3.088 7.335 2.186 10 2.186c2.665 0 4.8.902 5.592 1.922l-1.638 1.637h3.955V1.791L16.43 3.27Z",
    fill: "#666"
  })));
};
export default SvgSwipe;